<template>
  <div class="ajout etr">
    <b-form @submit="onSubmitDL" class="d-block forms">
      <h2 class="bold" v-if="titre_page != '[PRESTATION]'">{{ titre_page }}</h2>
      <p class="hight">{{ $t("Nouvelle demande") }}</p>
      <div class="container">
        <div class="row">
          <div class="bg-blue col-md-4">
            <h3 class="mb-3 bold">{{ $t("Informations générales") }}</h3>
            <DynField name="reference_client" v-model="forms.reference"></DynField>
            <b-form-group id="type_bien-group" label-for="type_bien" class="light size-part size-part-2">
              <template slot="label">{{ $t("Type de bien") }} <sup>*</sup></template>
              <b-form-radio-group buttons :options="this.options_type_bien" v-model='forms.type_bien' required
                id='forms_type_bien'></b-form-radio-group>
            </b-form-group>
            <b-form-group id="demande-group" label-for="demande" v-if="forms.opays !== ''" class="fph">
              <template slot="label">{{ $t("Renseignez une adresse") }} <sup>*</sup></template>
              <autocomplete placeholder="" id="demande" :source="getDataAddress" input-class="form-control"
                v-if="forms.demande === ''" results-property="data" :resultsFormatter="resultDataAddress"
                @focus="resetAddressData" :results-display="formattedDataAddress" required
                @selected="getAddressData($event, forms)" :delay="500">
              </autocomplete>
              <b-form-input id="adressed" v-model='forms.demande' v-if="forms.demande !== ''"
                @focus="resetAddressData"></b-form-input>
              <b-form-input id="adresse" v-model='forms.adresse' class='hidden'></b-form-input>
              <b-form-input id="code_postal" v-model='forms.code_postal' class='hidden'></b-form-input>
              <b-form-input id="ville" v-model='forms.ville' class='hidden'></b-form-input>
              <b-form-input id="pays" v-model='forms.pays' class='hidden'></b-form-input>
              <b-form-input id="lat" v-model='forms.lat' class='hidden' required></b-form-input>
              <b-form-input id="lng" v-model='forms.lng' class='hidden' required></b-form-input>
            </b-form-group>
            <b-form-group id="surface-group" label-for="surface" class="fph">
              <template slot="label">{{ $t("Surface habitable") }} <sup
                  v-if="forms.date_acquisition == ''">*</sup></template>
              <b-form-input id="surface" v-model='forms.surface' type="number" min="0" max="9999" required
                class="numCheck" v-if="forms.date_acquisition == ''"></b-form-input>
              <b-form-input id="surface" v-model='forms.surface' type="number" min="0" max="9999" class="numCheck"
                v-else></b-form-input>
              <span>m2</span>
            </b-form-group>
            <p class='alignIcon' v-if="estimation_reverse.show == true"><b><a href="#" @click="nosurface = !nosurface">Vous
                  ne
                  connaissez pas la surface habitable ? <span class="material-icons hight"
                    v-if="!nosurface">chevron_right</span><span class="material-icons hight"
                    v-else>expand_more</span></a></b></p>
            <div v-if="nosurface">
              <p class="nota">{{$t("Si la surface de votre bien est inconnue, nous estimerons la superficie en fonction de la date d’acquisition renseignée et son montant.")}}<br/><b>{{$t("L’estimation de la surface étant une donnée statistique, elle est soumise à un niveau de fiabilité plus ou moins élevé. Elle n’est donc pas garantie à 100%.")}}</b></p>
              <b-form-group id="date-acquisition-group" label-for="date-acquisition" class="fph">
                <template slot="label">{{ $t("Date d'acquisition") }} <sup v-if="forms.surface == ''">*</sup></template>
                <b-form-input id="date-acquisition" v-model='forms.date_acquisition' type="text" v-mask="'####-##'"
                  @keyup="check_datea" v-if="parseInt(forms.surface) > 0"
                  placeholder="Exemple : 2015-02 ou 2015"></b-form-input>
                <b-form-input id="date-acquisition" v-model='forms.date_acquisition' type="text" v-mask="'####-##'"
                  required @keyup="check_datea" v-else placeholder="Exemple : 2015-02 ou 2015"></b-form-input>
              </b-form-group>
              <b-form-group id="montant-acquisition-group" label-for="montant-acquisition" class="fph">
                <template slot="label">{{ $t("Montant de l'acquisition") }} <sup
                    v-if="forms.surface == ''">*</sup></template>
                <b-form-input id="montant-acquisition" v-model='forms.montant_acquisition' type="text"
                  pattern="([0-9]+.{0,1}[0-9]*,{0,1})*[0-9]" class="numCheck"
                  v-if="parseInt(forms.surface) > 0"></b-form-input>
                <b-form-input id="montant-acquisition" v-model='forms.montant_acquisition' type="text"
                  pattern="([0-9]+.{0,1}[0-9]*,{0,1})*[0-9]" required class="numCheck" v-else></b-form-input>
                <span>{{ $t("€") }}</span>
              </b-form-group>
            </div>
          </div>
          <div class="col-md-4 mt-10">
            <div class="bg-blue ml-4">
              <div class="row">
                <div class="col-md-6" v-if="analyse">
                  <b-form-group label-for="partner_demande_email" class="light redFirst">
                    <template slot="label">{{ $t('Je souhaite recevoir un email de confirmation de commande')}}</template>
                    <b-form-radio-group buttons v-model="forms.partner.demande_email" name="partner_demande_email"
                      :options="this.yesno"></b-form-radio-group>
                  </b-form-group>
                  <b-form-group label-for="partner_rapport_email" class="light redFirst">
                    <template slot="label">{{ $t('Je souhaite recevoir une email pour m’avertir de la publication du rapport et de la facture')}}</template>
                    <b-form-radio-group buttons v-model="forms.partner.rapport_email" name="partner_rapport_email"
                      :options="this.yesno"></b-form-radio-group>
                  </b-form-group>
                </div>
                <div :class="'col-md-' + (algo_option.Annonces == true ? (analyse ? '4' : '8 pt-5') : '12')">
                  <div class="panier mt-3" v-if="analyse">
                    <p class="bigText2"><b>{{ $t("Tarif") }} : {{ parseInt(panier.total.prix).toFixed(2) }}
                        {{ $t("€") }}</b></p>
                  </div>
                  <br />
                  <b-form-checkbox id="cgv" v-model="cgv_ok" value="1" unchecked-value="0"> {{ $t("Je reconnais avoir pris connaissance des")}} <a href="javascript:void(0)" @click="$bvModal.show('modal-cgu')">
                      {{ $t("Conditions Générales de Vente")}}</a> {{ $t("et les accepter sans réserve") }}.</b-form-checkbox><br />
                </div>
                <div :class="'text-right col-md-' + (algo_option.Annonces == true ? (analyse ? '2 pt-5' : '4') : '12')">
                  <b-button class="btn-gold" type="button" @click="onSubmitDL" :disabled="loading"><span
                      v-if="loading">{{ $t("Enregistrement") }} ...</span><span v-if="!loading">{{ $t("Evaluer le bien")}}</span></b-button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-3" v-if="algo_option.Annonces != true">
            <p class="text-gray">{{ $t("Les champs marqués d'une * sont obligatoires") }}</p>
          </div>
        </div>
      </div>
    </b-form>
    <b-modal id="modal-no-estimation" hide-footer content-class="">
      <template slot="modal-title">
        Information
      </template>
      <p
        v-if="forms.code_postal.substr(0, 2) == '57' || forms.code_postal.substr(0, 2) == '68' || forms.code_postal.substr(0, 2) == '67' || forms.code_postal.substr(0, 3) == '976'">
        {{ $t("La direction générale des Finances publiques ne dispose pas des mutations des départements du Bas-Rhin, Haut - Rhin, Moselle et Mayotte.")}}
      </p>
      <p v-else>{{$t("Nous ne disposons pas de données suffisantes pour vous proposer une " + user.infos_cli.menu.filter(e => (e.id =='menu_EVAL'))[0].title)}}</p>
      <div v-if="user.infos_cli.menu.filter(e => (e.id == 'menu_AVAL' || e.id == 'menu_EXIM')).length">
        <p>{{ $t("Si vous souhaitez une valorisation de ce bien, Ooftop vous propose :") }}</p>
        <br />
        <div class="row commande_links listing">
          <div class="col-md-6 text-center p-3" v-if="user.infos_cli.menu.filter(e => (e.id == 'menu_AVAL')).length">
            <a href="javascript:void(0)" @click="commander('avis_valeur')" class="btn-gold p-3 radius">
              <i><img :src="require('../../assets/img/ICOS/menu_AVAL.svg')" /></i>
              <span>{{ $t("Commander un avis de valeur") }}</span>
            </a>
          </div>
          <div class="col-md-6 text-center p-3" v-if="user.infos_cli.menu.filter(e => (e.id == 'menu_EXIM')).length">
            <a href="javascript:void(0)" @click="commander('expertises_immobilieres')" class="btn-gold p-3 radius">
              <i><img :src="require('../../assets/img/ICOS/menu_EXIM.svg')" /></i>
              <span>{{ $t("Commander une expertise immobilière") }}</span>
            </a>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-pays-disabled" hide-footer content-class="">
      <template slot="modal-title">
        Information
      </template>
      <p>{{ $t("Ce département n'est pas disponible pour le moment. Nous vous invitons à contacter notre service commercial à l'adresse suivante :")}} <a :href="'mailto:' + ste_email" id="ste_email">{{ ste_email }}</a></p>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import VueInputMask from 'v-mask';
import DynField from '@/components/Fields/DynField'
export default {
  components: { VueInputMask, DynField },
  data() {
    return {
      infos_cli: { nom: '', societe: [], partner: [] },
      user: {},
      ste_label: '',
      ste_email: '',
      analyse: false,
      options_pays: [
        { value: "FR", text: "France métropolitaine" },
        { value: "GP", text: "Guadeloupe" },
        { value: "GF", text: "Guyane française" },
        { value: "RE", text: "La Réunion" },
        { value: "MQ", text: "Martinique" },
        { value: "YT", text: "Mayotte" },
        { value: "NC", text: "Nouvelle Calédonie" },
        { value: "PF", text: "Polynésie française" },
        { value: "BL", text: "Saint-Barthélemy" },
        { value: "MF", text: "Saint-Martin" },
        { value: "PM", text: "Saint-Pierre-et-Miquelon" },
        { value: "TF", text: "Terres australes et antarctiques françaises" },
        { value: "WF", text: "Wallis-et-Futuna" }
      ],
      options_nbc: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7+" },
      ],
      options_nbc2: [
        { value: "0", text: "0" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6+" },
      ],
      options_pays_disabled: ["MQ", "NC", "PF", "PM", "TF", "WF"],
      options_type_bien: [
        { value: "Appartement", html: this.$i18n.t("Appartement") },
        { value: "Maison", html: this.$i18n.t("Maison") },
      ],
      yesno: [
        { value: "0", text: this.$i18n.t("Non") },
        { value: "1", text: this.$i18n.t("Oui") }
      ],
      nosurface: 0,
      cgv_ok: 0,
      forms: {
        type_formulaire: 'Simple',
        reference: '',
        type_bien: '',
        surface: '',
        carrez: '',
        terrain: '',
        construction: '',
        demande: '',
        adresse: '',
        code_postal: '',
        code_insee: '',
        ville: '',
        pays: '',
        opays: 'FR',
        lat: '',
        lng: '',
        surface_connue: 1,
        date_acquisition: '',
        montant_acquisition: '',
        elevation: { min: '', max: '' },
        nb_pieces: {
          total: '',
          chambre: '',
          sejour: '',
          salle_eau: '',
          salle_bain: '',
          cuisine: '',
          cuisine_separee: '',
          salle_manger: '',
          toilette_separee: '',
          buanderie: '',
          dressing: '',
          entree: '',
          veranda: '',
        },
        partner: {
          demande_email: false,
          rapport_email: false,
        }
      },
      panier: { panier: [], nb: [], total: { prix: 0 } },
      loading: false,
    }
  },
  created() {
    this.get_infos_cli();
    this.user = JSON.parse(localStorage.getItem('user'));
  },
  mounted() {
    var p = this;
    if (p.get_first_route() == 'evaluations_analyse') p.analyse = true;
    if (p.analyse) {
      p.check_price('EXETR', this.forms);
    }
    else {
      axios.get(this.$apiUrl + "params/fields/field_estimation_reverse?auth=" + JSON.stringify(this.auth_header())).then(response => {
        localStorage.setItem('estimation_reverse', JSON.stringify(response.data));
      })
    }
    window.setInterval(function () {
      const inputsEOF = document.querySelectorAll(".form-group:not(.init)")
      for (let ieof of inputsEOF) {
        ieof.classList.add('init');
        let ineof = ieof.querySelector('input');
        ineof.addEventListener('focus', function () {
          ieof.classList.add('focus');
        });
        ineof.addEventListener('blur', function () {
          if (this.value != '') ieof.classList.add('filled');
          else ieof.classList.remove('filled');
          ieof.classList.remove('focus');
        });
      }
    }, 2500)
  },
  methods: {
    getDataAddress(obj) { return "https://data.geopf.fr/geocodage/search/?q=" + obj; },
    resultDataAddress(response) { return response.features; },
    formattedDataAddress(result) {
      const typeGeo = { 'housenumber': 'numéro', 'street': 'rue', 'locality': 'lieu-dit', 'municipality': 'commune' };
      if (result) {
        return '<b>' + result.properties.label + '</b><br/><small>' + result.properties.context + '</small><i>' + typeGeo[result.properties.type] + '</i>';
      }
    },
    getAddressData(group, f) {
      f.demande = group.selectedObject.properties.label;
      f.adresse = group.selectedObject.properties.name;
      f.code_postal = group.selectedObject.properties.postcode;
      f.code_insee = group.selectedObject.properties.citycode;
      f.ville = group.selectedObject.properties.city;
      f.pays = 'France';
      f.lat = group.selectedObject.geometry.coordinates[1];
      f.lng = group.selectedObject.geometry.coordinates[0];
    },
    resetAddressData: function () {
      this.forms.demande = "";
      this.forms.adresse = "";
      this.forms.code_postal = "";
      this.forms.ville = "";
      this.forms.pays = "";
      this.forms.lat = "";
      this.forms.lng = "";
      this.forms.opays = "FR";
    },
    check_pays() {
      var p = this;
      if (this.includes(this.options_pays_disabled, this.forms.opays)) {
        p.$bvModal.show('modal-pays-disabled');
      }
    },
    check_datea() {
      if (this.forms.date_acquisition.length == 7) {
        var vda = this.forms.date_acquisition.split('-');
        if (vda[1] > 12) {
          this.infosModal('warning', this.$i18n.t('Merci de bien vouloir renseigner une date correcte (le mois devant être compris entre 01 et 12).'), false, 'Format de date');
          this.forms.date_acquisition = vda[0];
        }
      } return true;
    },
    onSubmitDL(evt) {
      evt.preventDefault();
      var error = 0;
      error = this.check_form(".ajout form");
      var p = this;
      /*if(this.forms.code_postal.substr(0,2)=='57' || this.forms.code_postal.substr(0,2)=='67' || this.forms.code_postal.substr(0,2)=='68' || this.forms.code_postal.substr(0,3)=='976'){
        p.$bvModal.show('modal-no-estimation');
      }
      else */
      if (error > 0) this.infosModal('warning', this.$i18n.t('Merci de bien vouloir remplir tous les champs suivants correctement avant de valider votre demande') + ' : ' + this.errorTxt, false, this.$i18n.t('Champs incomplets'));
      else if (this.cgv_ok != 1) { this.infosModal('warning', this.$i18n.t("Merci d'accepter les conditions générales de vente."), false, 'Informations'); }
      else {
        this.loading = true;
        let formData = new FormData();
        p.surface_connue = (document.getElementById('surface').value != '');
        formData.append('datas', JSON.stringify(p.forms));
        axios.post(p.$apiUrl + "demandes/submit/" + (p.analyse ? "EXETR" : "EVAL") + "?lang=" + this.$i18n.locale + "&auth=" + JSON.stringify(p.auth_header()), formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (response) {
          if (response.data.error == 'notlogged') {
            p.logout();
            p.$router.push({ path: '/' });
          }
          if (response.data.success) {
            if (response.data.successId > 0) {
              if (p.analyse) p.infosModal('success', response.data.success, 'evaluations_analyse', 'Confirmation');
              else p.$router.push({ path: '/evaluations/detail/' + response.data.successId });
            }
            else {
              p.$bvModal.show('modal-no-estimation');
            }
            /*p.resetAddressData();*/

            p.forms.opays = "FR";
            p.forms.surface = "";
            p.forms.date_acquisition = "";
            p.forms.montant_acquisition = "";
          } else {
            if (p.forms.code_postal.substr(0, 2) == '57' || p.forms.code_postal.substr(0, 2) == '67' || p.forms.code_postal.substr(0, 2) == '68' || p.forms.code_postal.substr(0, 3) == '976') {
              p.$bvModal.show('modal-no-estimation');
            }
            else if (response.data.error != "") p.infosModal('warning', response.data.error, false, 'Informations');
          }
          p.loading = false;
        }).catch(function (error) {
          p.loading = false;
        });
      }
    },
  },
  computed: {
    algo_option: function () {
      if (this.analyse) return { DVF: true, Annonces: true, DVF_V2: false };
      return { DVF: false, Annonces: false, DVF_V2: false, test: false };
    },
    estimation_reverse: function () {
      return (localStorage.getItem('estimation_reverse') ? JSON.parse(localStorage.getItem('estimation_reverse')) : { show: false, required: false });
    },
    titre_page: function () {
      let user = JSON.parse(localStorage.getItem('user'));
      if (user.infos_cli.menu.filter(p => (p.id == 'menu_EVAL')).length) {
        return this.$i18n.t(user.infos_cli.menu.filter(p => (p.id == 'menu_EVAL'))[0]['title']);
      }
      return this.$i18n.t(this.$route.meta.title.replace(' - Ooftop', '').split(' - ')[1]);
    }
  },
}
</script>